import React, { createContext, useState } from 'react';

import Icon from '@mdi/react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import styled from 'styled-components';

type ContextType = {
    handleItemClick?: (e) => void;
};

export const ButtonMenuContext = createContext<ContextType>({});

type HandleItemClick = (e: React.MouseEvent<HTMLButtonElement>, menuId?: string | number) => void;

export interface ButtonMenuProps {
    id: string | number;
    handleItemClick: HandleItemClick;
    label?: string;
    icon?: string;
    ariaLabel?: string;
    variant?: 'text' | 'outlined' | 'contained';
    className?: string;
}

const StyledIcon = styled(Icon)`
    min-width: 30px;
`;

const ButtonMenu: React.FC<ButtonMenuProps> = (props) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const menuHandleItemClick = (e) => {
        props.handleItemClick(e, props.id);
        handleClose();
    };
    const menuId = `custom-menu-${props.id}`;
    const menuButtonId = `button-${menuId}`;
    return (
        <ButtonMenuContext.Provider value={{ handleItemClick: menuHandleItemClick }}>
            <Button
                id={menuButtonId}
                data-testid={menuButtonId}
                aria-controls={open ? menuId : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                aria-label={props.ariaLabel}
                onClick={handleClick}
                variant={props?.variant ?? 'text'}
                className={props.className}
            >
                {props.icon && <StyledIcon path={props.icon}></StyledIcon>}
                {props.label && <span>{props.label}</span>}
            </Button>
            <Menu
                id={menuId}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': menuButtonId
                }}
            >
                {props.children}
            </Menu>
        </ButtonMenuContext.Provider>
    );
};

export default ButtonMenu;
